import { useState, useEffect, useId } from 'react';
import { subscribe } from 'app/helpers/cable';

type BalanceMessage = {
  balance: string | number;
  bonus: string | number;
};

const useBalance = (initialData: BalanceMessage): BalanceMessage => {
  const [msg, setMsg] = useState(initialData);
  const channelId = useId();

  useEffect(() => {
    const { unsubscribe } = subscribe(
      {
        channel: 'BalanceChannel',
        channelId,
      },
      {
        received: setMsg,
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return msg;
};

export default useBalance;
